export default __webpack_public_path__ + "static/media/mlm.9dff0449.svg";